import axios from 'axios';
import { getApiRoot } from '../../constants/ParamountReactConstants';
import * as utils from '../../utils/Utils';
import { ReceiverInvite } from '../../../types/receiver';

export const approveReceivers = ({
  receiverId,
  brandIds,
  selectedPriceSheetIds,
  selectedPriceTypeIds,
  withoutPrices,
  filterIds,
  withoutInterchanges,
  interchangeQualityIds,
  withoutCustomFields,
  customFieldIds,
}: {
  receiverId: number;
  brandIds: number[];
  selectedPriceSheetIds: number[];
  selectedPriceTypeIds: number[];
  withoutPrices: boolean;
  filterIds: number[];
  withoutInterchanges: boolean;
  interchangeQualityIds: number[];
  withoutCustomFields: boolean;
  customFieldIds: number[];
}) => {
  const dbWithoutPrices = withoutPrices ? 1 : 0;
  const urlParams = utils.createURL([
    { name: 'requesting_receiver_id', values: receiverId },
    { name: 'brand_ids', values: brandIds },
    { name: 'price_sheet_ids', values: selectedPriceSheetIds },
    { name: 'price_type_ids', values: selectedPriceTypeIds },
    { name: 'without_prices', values: dbWithoutPrices },
    { name: 'filter_ids', values: filterIds },
    { name: 'with_interchange_type_records', values: interchangeQualityIds },
    { name: 'without_interchanges', values: withoutInterchanges ? 1 : 0 },
    { name: 'without_custom_fields', values: withoutCustomFields ? 1 : 0 },
    { name: 'custom_field_ids', values: customFieldIds },
  ]);

  return {
    type: 'APPROVE_RECEIVERS',
    meta: {
      receiverId,
      brandIds,
      selectedPriceSheetIds,
      selectedPriceTypeIds,
      withoutPrices: dbWithoutPrices,
      filterIds,
      withoutInterchanges,
      interchangeQualityIds,
      withoutCustomFields,
      customFieldIds,
    },
    payload: axios.patch(
      `${getApiRoot()}/parents/receivers/authorized_brands/approve_receiver_request${urlParams}`
    ),
  };
};

export const declineReceivers = (params: {
  receiverId: number;
  brandIds: number[];
  reason?: string;
}) => {
  const urlParams = utils.createURL([
    { name: 'requesting_receiver_id', values: params.receiverId },
    { name: 'brand_ids', values: params.brandIds },
    { name: 'declined_by_brand_reason', values: params.reason },
  ]);

  return {
    type: 'DECLINE_RECEIVERS',
    meta: { receiverId: params.receiverId, brandIds: params.brandIds, reason: params.reason },
    payload: axios.patch(
      `${getApiRoot()}/parents/receivers/authorized_brands/decline_receiver_request${urlParams}`
    ),
  };
};

export const cancelRequests = (params: { receiverId: number; brandIds: number[] }) => {
  const urlParams = utils.createURL([
    { name: 'requesting_receiver_id', values: params.receiverId },
    { name: 'brand_ids', values: params.brandIds },
  ]);

  return {
    type: 'CANCEL_REQUESTS',
    meta: { receiverId: params.receiverId, brandIds: params.brandIds },
    payload: axios.patch(
      `${getApiRoot()}/parents/receivers/authorized_brands/cancel_receiver_request${urlParams}`
    ),
  };
};

export const receiverBulkInvite = (values: ReceiverInvite[]) => {
  return {
    type: 'RECEIVER_BULK_INVITE',
    payload: axios.post(`${getApiRoot()}/receivers/create`, {
      receivers: values,
    }),
  };
};

export const receiverBulkInviteByFile = (file: any) => {
  const config = {
    headers: { 'Content-Type': file.type },
  };
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);

  return {
    type: 'RECEIVER_BULK_INVITE',
    payload: axios.post(`${getApiRoot()}/receivers/create`, bodyFormData, config),
  };
};

export const createReceiverDetailsRequest = (receiverId: number) => {
  const urlParams = utils.createURL([{ name: 'receiver_id', values: receiverId }]);
  return {
    type: 'CREATE_RECEIVER_DETAILS_REQUEST',
    meta: { receiverId },
    payload: axios.post(`${getApiRoot()}/parents/receivers/request_receiver_details${urlParams}`),
  };
};

export const requestTrafficDataRefresh = (
  receiverId: number,
  websiteIds?: number[],
  force = false
) => {
  return {
    type: 'REQUEST_TRAFFIC_DATA_REFRESH',
    payload: axios.post(`${getApiRoot()}/receivers/${receiverId}/websites/refresh-traffic`, {
      website_ids: websiteIds,
      force,
    }),
    meta: { receiverId, websiteIds, force },
  };
};
